<template>
   <div>
      <div class="jumbotron">
      </div>
      <div class="container card col-md-6 col-lg-6 col-sm-12 mt-5">
         <div class="card-body">
            <!-- <input type="text" class="form-control my-1" placeholder="Username">
            <input type="password" class="form-control my-1" placeholder="Password">
            <div class="text-center">
               <button class="btn btn-primary">Login</button>
               <p>Belum memiliki akun ?, <b>Mendaftar</b></p>
            </div> -->
   
            <div class="text-center">
               <h2>Studi Quran</h2>
               <img src="@/assets/banner.jpg" style="width:300px" alt="" class="img-fluid "> <br/>
               
               <button class="btn btn-lg btn-danger mt-5" @click="login"> <font-awesome-icon icon="fa-brands fa-google" /> Login by Google</button>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import { GoogleAuthProvider, signInWithPopup, getAuth } from 'firebase/auth';
import { mapActions } from 'vuex';
import cookie from 'vue-cookie'

export default {
   created() {
      const token = cookie.get("token");
      if(token) this.$router.push({ name: 'home' });
   },
   methods:{
      ...mapActions('auth', ['loginByGoogle']),
      login() {
         const provider = new GoogleAuthProvider();
         const auth = getAuth();

         signInWithPopup(auth, provider)
               .then((result) => {
                  this.loginByGoogle({
                     email: result.user.email,
                     uid: result.user.uid
                  })
                     .then(() => {
                           // this.$refs.toastLoginSuccess.click();
                           const userProfile = {
                                image: result.user.photoURL,
                                name: result.user.displayName,
                                email: result.user.email
                           };
                           this.$store.dispatch('changeProfile', userProfile);
                           let route = this.$route.name;
                           if(route != 'home') {
                              this.$router.push({ name: 'home' });
                           }
                     })
                     .catch(err => console.log(err));
               })
               .catch(error => {
                  const errorCode = error.code;
                  const errorMessage = error.message;
                  console.log(errorCode, errorMessage);
               })
      }
   }
}
</script>

<style scoped>

</style>